import * as Yup from 'yup'

export const AppMakerSchema = Yup.object().shape({
  account_mail: Yup.string().required('emailErr'),
  account_password: Yup.string().required('passwordErr'),
  app_icon: Yup.string().required('imageErr'),
  is_agree: Yup.boolean().required('checkErr'),
  duns_num: Yup.string().when('active', {
    is: 1,
    then: Yup.string().required('imageErr'),
    otherwise: Yup.string(),
  }),
  working_email: Yup.string().when('active', {
    is: 0,
    then: Yup.string().required('imageErr'),
    otherwise: Yup.string(),
  }),
  commercial_file: Yup.string().when('active', {
    is: 0,
    then: Yup.string().required('fileErr'),
    otherwise: Yup.string(),
  }),

  id_face_one: Yup.string()
    .nullable()
    .when(['active', 'check'], {
      is: (active: any, check: any) => active === 0 && check === 1, // الشرط للتحقق
      then: Yup.string().required('imageErr'), // إذا تحقق الشرط
      otherwise: Yup.string().nullable(), // الحقل غير مطلوب ويمكن أن يكون null
    }),
  passport: Yup.string()
    .nullable()
    .when(['active', 'check'], {
      is: (active: any, check: any) => active === 0 && check === 0, // الشرط للتحقق
      then: Yup.string().required('imageErr'), // إذا تحقق الشرط
      otherwise: Yup.string().nullable(), // الحقل غير مطلوب ويمكن أن يكون null
    }),
  id_face_two: Yup.string()
    .nullable()
    .when(['active', 'check'], {
      is: (active: any, check: any) => active === 0 && check === 1, // نفس الشرط للحقل الثاني
      then: Yup.string().required('imageErr'),
      otherwise: Yup.string().nullable(), // الحقل غير مطلوب ويمكن أن يكون null
    }),
})
